import type { RenovationType } from 'shared/models/space-renovation-requests';

export default function convertRenovationTypesToString(
  renovationTypes: RenovationType[]
) {
  let res: string[] = [];

  for (let renovationType of renovationTypes) {
    if (renovationType.Type?.Label) {
      res.push(renovationType.Type.Label);
    }
  }

  return res.join(', ');
}
